import { useEffect, useRef, useState } from "react";
import "./HeaderWeb.scss";
import profile from './assets/profile.svg';
import wishList from './assets/heart1.svg';
import cartBag from './assets/cart1.svg';
import axios from "axios";
import { getData } from "./Data";
import { useProfile } from "../../Contexts/ProfileContext";
import { clearAuthStorage, clearGuestData } from "../../utils/storage";
import { getAccountMenuLinks } from "../shared/accountMenuConfig";

import { IoIosArrowDown } from "react-icons/io";
import { IoSearch } from "react-icons/io5";
import { Link, useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { SEARCH_SUGGESTIONS } from "../../Products/data/phoneCaseFilters";
import { HeaderBrandMark } from "../../Brand/HeaderBrandMark";
import { BUSINESS } from "../../Legal/legalContent";

export function HeaderWeb() {
    const { profileData, loading, error, isProfileLoaded, fetchProfile } = useProfile();
    const location = useLocation();

    const [data2, setData2] = useState(SEARCH_SUGGESTIONS);

    const ref = useRef(null)
    const searchInputRef = useRef(null)
    const recognitionRef = useRef(null)
    const profileMenuCloseTimer = useRef(null)
    const [showSearchRecommendation, setShowSearchRecommendation] = useState(false);
    const [isAllProductsMenuOpen, setIsAllProductsMenuOpen] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [guestCartVersion, setGuestCartVersion] = useState(0);
    const [badgePulse, setBadgePulse] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [isMicListening, setIsMicListening] = useState(false);
    const [voiceSearchSupported, setVoiceSearchSupported] = useState(false);
    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

    const navigate = useNavigate();

    const openProfileMenu = () => {
        if (profileMenuCloseTimer.current) {
            clearTimeout(profileMenuCloseTimer.current);
            profileMenuCloseTimer.current = null;
        }
        setIsProfileMenuOpen(true);
    };

    const closeProfileMenu = () => {
        profileMenuCloseTimer.current = setTimeout(() => {
            setIsProfileMenuOpen(false);
        }, 200);
    };

    const isGuest = localStorage.getItem('guestUser') === 'true';

    useEffect(() => {
        return () => {
            if (profileMenuCloseTimer.current) {
                clearTimeout(profileMenuCloseTimer.current);
            }
        };
    }, []);

    useEffect(() => {
        const h = () => setGuestCartVersion((v) => v + 1);
        window.addEventListener('guestCartUpdated', h);
        return () => window.removeEventListener('guestCartUpdated', h);
    }, []);
    useEffect(() => {
        const onPulse = () => { setBadgePulse(true); setTimeout(() => setBadgePulse(false), 350); };
        window.addEventListener('cartBadgePulse', onPulse);
        return () => window.removeEventListener('cartBadgePulse', onPulse);
    }, []);
    useEffect(() => {
        if (localStorage.getItem('token') || profileData?.data || isGuest) {
            setIsLoggedIn(true);
        }
    }, [profileData?.data, isGuest]);

    // Re-fetch profile when landing on home with token but no profile (e.g. after verify)
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token && location.pathname === '/' && !profileData?.data) {
            fetchProfile(true);
        }
    }, [location.pathname]);

    const capitalize = (s) => s ? s.split(' ').map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ') : s;

    const PROFILE_NAME_MAX_CHARS = 7;

    const formatHeaderProfileName = (name) => {
        if (!name) return 'User';
        if (name.length <= PROFILE_NAME_MAX_CHARS) return name;
        return `${name.slice(0, PROFILE_NAME_MAX_CHARS)}...`;
    };

    // Get display name from profile data or guest
    const getDisplayName = () => {
        let name = '';
        if (profileData?.data) {
            const { firstName, lastName } = profileData.data;
            if (firstName && lastName) name = `${firstName} ${lastName}`;
            else if (firstName) name = firstName;
            else if (lastName) name = lastName;
        } else if (isGuest) {
            const f = localStorage.getItem('guestFirstName') || '';
            const l = localStorage.getItem('guestLastName') || '';
            name = (f + ' ' + l).trim() || 'Guest';
        }
        if (!name) return 'User';
        return capitalize(name);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowSearchRecommendation(false);
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;

        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) return undefined;

        setVoiceSearchSupported(true);
        const recognition = new SpeechRecognition();
        recognition.lang = 'en-IN';
        recognition.interimResults = true;
        recognition.continuous = false;
        recognition.maxAlternatives = 1;

        recognition.onstart = () => setIsMicListening(true);
        recognition.onend = () => setIsMicListening(false);
        recognition.onerror = () => setIsMicListening(false);
        recognition.onresult = (event) => {
            const transcript = Array.from(event.results)
                .map((result) => result?.[0]?.transcript || '')
                .join(' ')
                .trim();

            setSearchQuery(transcript);
            const latestResult = event.results[event.resultIndex];
            if (latestResult?.isFinal && transcript) {
                changeTwitch();
                setShowSearchRecommendation(true);
                searchInputRef.current?.focus();
            }
        };

        recognitionRef.current = recognition;

        return () => {
            recognition.onstart = null;
            recognition.onend = null;
            recognition.onerror = null;
            recognition.onresult = null;
            recognition.stop();
            recognitionRef.current = null;
        };
    }, []);

    // Lock body scroll when All Products dropdown is open so overlay doesn't let scroll pass through to main content
    useEffect(() => {
        if (isAllProductsMenuOpen) {
            const prev = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            return () => {
                document.body.style.overflow = prev;
            };
        }
    }, [isAllProductsMenuOpen]);

    // Profile data is now handled by ProfileContext

    const [triggeredSeacrch, setTriggeredSeacrch] = useState(null);

    useEffect(() => {
        let getData = setTimeout(() => {

        }, 2000);;
        if (triggeredSeacrch == 'switch') {
            getData = setTimeout(() => {
                axios
                    .get(`https://jsonplaceholder.typicode.com/todos/1`)
                    .then((response) => {
                        console.log(response.data);
                    });
                setShowSearchRecommendation(true);
            }, 2000)
        }
        else if (triggeredSeacrch === 'twitch') {
            getData = setTimeout(() => {
                axios
                    .get(`https://jsonplaceholder.typicode.com/todos/1`)
                    .then((response) => {
                        console.log(response.data);
                    });
                setShowSearchRecommendation(true);
            }, 2000)
        }

        return () => clearTimeout(getData)
    }, [triggeredSeacrch])

    // useEffect(() => {
    //     let getData = setTimeout(() => {

    //     }, 2000);
    //     let token = localStorage.getItem('token')
    //     if (token) {
    //         getData = setTimeout(() => {
    //             console.log('token - ', token);
    //             const config = {
    //                 headers: { Authorization: `Bearer ${token}` }
    //               };

    //               const bodyParameters = {
    //                 // key: "value"
    //               };
    //             axios
    //                 .post('http://localhost:4000/profile', bodyParameters, config)
    //                 .then((response) => {
    //                     console.log(response.data);
    //                     setName(response.data.name)
    //                 });
    //             // setShowSearchRecommendation(true);
    //         }, 2000)
    //     }
    //     else if (triggeredSeacrch === 'twitch') {
    //         getData = setTimeout(() => {
    //             axios
    //                 .get(`https://jsonplaceholder.typicode.com/todos/1`)
    //                 .then((response) => {
    //                     console.log(response.data);
    //                 });
    //             setShowSearchRecommendation(true);
    //         }, 2000)
    //     }

    //     return () => clearTimeout(getData)
    // }, [])

    function changeTwitch() {
        setTriggeredSeacrch((prev) => (prev === 'switch' ? 'twitch' : 'switch'));
    }

    function handleSearchInputChange(event) {
        setSearchQuery(event.target.value);
        changeTwitch();
    }

    function handleMicClick() {
        if (!voiceSearchSupported || !recognitionRef.current) return;

        if (isMicListening) {
            recognitionRef.current.stop();
            return;
        }

        setShowSearchRecommendation(false);
        try {
            recognitionRef.current.start();
        } catch (_error) {
            setIsMicListening(false);
        }
    }

    function optionListData(pos) {
        return (
            getData(pos).map((column, key) => {
                return <div> {column.map((category, key) => {
                    return (
                        <div className={key > 0 ? column[key - 1].length === 1 ? null : 'seperator' : null}>{category.map((section, key) => {
                            return (
                                <div className={key === 0 ? 'sectionTitle' : null} onClick={() => navigate(`/products/${category[0]}/${section}`)}>
                                    {section}
                                </div>
                            )
                        })}</div>
                    )
                })}
                </div>
            })
        )
    }

    function handleLogout() {
        clearAuthStorage();
        setIsLoggedIn(false);
        navigate(`/auth/login`)
    }

    function handleLoginAsUser() {
        setIsLoggedIn(false);
        navigate('/auth/login');
    }

    function handleLogoutAsGuest() {
        clearGuestData();
        setIsLoggedIn(false);
        navigate('/');
    }

    const accountMenuLinks = getAccountMenuLinks(getDisplayName());

    return (
        <div className="header-web">
            <div className="top">
            </div>
            <div className="middle">
                <div
                    className="logoContainer header-brand header-brand--native"
                    onClick={() => navigate("/")}
                    role="link"
                    aria-label={`${BUSINESS.brandName} — Home`}
                >
                    <HeaderBrandMark />
                </div>

                <div className="optionsContainer">
                    <div className="options" onMouseOver={() => setShowSearchRecommendation(false)}>

                        <div
                            onMouseEnter={() => setIsAllProductsMenuOpen(true)}
                            onMouseLeave={() => setIsAllProductsMenuOpen(false)}
                        >
                            <span>All Products</span>
                            <span></span>

                            <div className="overlay">

                                <div className="optionsListContainer">
                                    {optionListData(1)}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="searchBarContainer" ref={ref}>
                    <div className="searchBar">
                        <span className="searchBarIcon" aria-hidden="true">
                            <IoSearch />
                        </span>
                        <div className="inputDiv">
                            <input
                                ref={searchInputRef}
                                type="text"
                                placeholder="Search Products & Brands"
                                value={searchQuery}
                                onChange={handleSearchInputChange}
                            />
                        </div>
                        <button
                            type="button"
                            className={`searchBarMic${isMicListening ? ' is-listening' : ''}`}
                            onClick={handleMicClick}
                            disabled={!voiceSearchSupported}
                            aria-label={isMicListening ? 'Stop voice search' : 'Start voice search'}
                            title={voiceSearchSupported ? 'Search with voice' : 'Voice search is not supported in this browser'}
                        >
                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M12 15.5a3.75 3.75 0 003.75-3.75V7.75a3.75 3.75 0 10-7.5 0v4A3.75 3.75 0 0012 15.5zm6-3.75a.75.75 0 011.5 0 7.5 7.5 0 01-6.75 7.46V21.5h2.5a.75.75 0 010 1.5h-6.5a.75.75 0 010-1.5h2.5v-2.29A7.5 7.5 0 014.5 11.75a.75.75 0 011.5 0 6 6 0 0012 0z" />
                            </svg>
                        </button>

                    </div>

                    <div className="aligner">

                        <div className="searchContainer" style={showSearchRecommendation ? { visibility: 'visible' } : { visibility: "hidden" }}>

                            {data2.map((item, key) => {
                                return (
                                    <div onClick={() => navigate(`/products/${item}`)}>
                                        {item}
                                    </div>
                                )
                            })}

                        </div>
                    </div>

                </div>

                <div className="right-options">
                    <div
                        className={`profile-menu${isProfileMenuOpen ? ' profile-menu--open' : ''}`}
                        onMouseEnter={openProfileMenu}
                        onMouseLeave={closeProfileMenu}
                    >
                        <img src={profile} />

                        <div
                            className="profile-menu__label"
                            title={isLoggedIn ? getDisplayName() : undefined}
                        >
                            {isLoggedIn ? formatHeaderProfileName(getDisplayName()) : 'Profile'}
                            <span><IoIosArrowDown /></span>

                        </div>


                        <span className="profileOptions">
                            {isLoggedIn && (
                                <div className="accountList">
                                    <p className="accountList__heading">My account</p>
                                    <ul className="accountList__menu">
                                        {accountMenuLinks.map((item) => (
                                            <li key={item.to}>
                                                <Link to={item.to} className="accountList__link">
                                                    <span
                                                        className={`accountList__icon accountList__icon--${item.variant}`}
                                                        aria-hidden
                                                    >
                                                        <i className={`bi ${item.icon}`} />
                                                    </span>
                                                    <span className="accountList__label">{item.label}</span>
                                                    <i className="bi bi-chevron-right accountList__chevron" aria-hidden />
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            <div className="accountInfoNonLoggedIn">
                                {isLoggedIn ? (
                                    isGuest ? (
                                        <div className="accountGuestActions">
                                            <span className="accountBtn btn rippleWhite" onClick={() => handleLoginAsUser()}>
                                                Login as full user
                                            </span>
                                            <span className="accountGuestLink" onClick={() => handleLogoutAsGuest()}>
                                                End guest session
                                            </span>
                                        </div>
                                    ) : (
                                        <span className="accountBtn btn rippleWhite" onClick={() => handleLogout()}>
                                            Logout
                                        </span>
                                    )
                                ) : (
                                    <>
                                        <p className="newUser"><span>If you are a new user</span></p>
                                        <span className="newUserRegister" onClick={() => navigate('/auth/register')}>Register</span>
                                        <span className="accountBtn btn rippleWhite" onClick={() => navigate('/auth/login')}>Login</span>
                                    </>
                                )}
                            </div>
                        </span>


                    </div>
                    <div onClick={() => navigate(`/wishlist`)}>
                        <img src={wishList} />
                        <div>Wishlist</div>
                    </div>
                    <div onClick={() => navigate(`/cart`)} className="cart-container">
                        <div className="cart-icon-wrapper">
                            <img src={cartBag} />
                            {(() => {
                                const count = (guestCartVersion, isGuest)
                                    ? JSON.parse(localStorage.getItem('guestCart') || '[]').reduce((s, i) => s + (i.selectedQty || 1), 0)
                                    : profileData?.data?.cartCount || 0;
                                return count > 0 && (
                                    <span className={`cart-badge ${badgePulse ? 'cart-badge--pulse' : ''}`}>
                                        {count > 99 ? '99+' : count}
                                    </span>
                                );
                            })()}
                        </div>
                        <div>Bag</div>
                    </div>
                </div>
            </div>

        </div>
    )
}